import { useHeaderDispatch } from 'hooks/useHeaderContext/useHeaderDispatch'

import { useMenuDispatch } from '../components/Menu/context/useMenuDispatch'
import { useMenuState } from '../components/Menu/context/useMenuState'

export function useMenus() {
	const { open, hasOpened, brandSelected } = useMenuState()
	const dispatch = useMenuDispatch()
	const dispatchHeader = useHeaderDispatch()

	const updateOpen = (newValue: boolean) => {
		dispatch({ open: newValue })
	}

	const updateHasOpened = (newValue: boolean) => {
		dispatch({ hasOpened: newValue })
	}

	const updateBrandSelected = (newValue: string | null) => {
		dispatch({ brandSelected: newValue })
		dispatchHeader({ brandId: newValue })
	}

	return {
		open,
		hasOpened,
		brandSelected,
		updateOpen,
		updateHasOpened,
		updateBrandSelected,
	}
}
